import { type ReactElement, type ReactNode } from 'react'
import { ScrollArea, Stack } from '@mantine/core'
import { Size } from '@front/model'
import { MaterialSymbolIcon } from '@components'
import { DashboardScopeOptionButton } from '../DashboardScopeOptionButton'

/** Scrolling container shared by the team / role / person sub-lists. */
export function AudienceOptionList({ children }: { children: ReactNode }): ReactElement {
  return (
    <ScrollArea.Autosize mah={260}>
      <Stack gap={Size.gap.list}>{children}</Stack>
    </ScrollArea.Autosize>
  )
}

type AudienceOptionRowProps = {
  isSelected: boolean
  children: ReactNode
  onSelect: () => void
}

export function AudienceOptionRow({ isSelected, children, onSelect }: AudienceOptionRowProps): ReactElement {
  return (
    <DashboardScopeOptionButton onClick={onSelect}>
      <span className='gap-2xl flex w-full items-center justify-between'>
        {children}
        {isSelected && <MaterialSymbolIcon filled icon='check_circle' size='md' />}
      </span>
    </DashboardScopeOptionButton>
  )
}
